import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { IEmployeeWizardFormModel } from "../models/employeeWizardFormModel";

/**
 * "Can't open other instructors' classes" only makes sense while the employee sees
 * every class, so it is offered only when "sees only their own classes" is off, and
 * switched off when that stricter option is turned on.
 */
export const useLockOthersEventsToggle = (
  form: UseFormReturn<IEmployeeWizardFormModel>
) => {
  const viewOnlyOwnEvents = form.watch("viewOnlyOwnEvents");

  useEffect(() => {
    if (viewOnlyOwnEvents && form.getValues("lockOthersEvents")) {
      form.setValue("lockOthersEvents", false);
    }
  }, [viewOnlyOwnEvents]);

  return { showLockOthersEventsToggle: !viewOnlyOwnEvents };
};
